import React from 'react';
import EChartsReact from 'echarts-for-react';
import { generateColors, getValueFromPercent } from 'utils/helpers';

interface QuestionData {
    name: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any;
    total: number;
}

interface Props {
    data: QuestionData[];
    layout?: 'horizontal' | 'vertical';
}

const QuestionStackedColumnChartCompare: React.FC<Props> = ({
    data,
    layout = 'horizontal',
}) => {
    const isHorizontal = layout === 'horizontal';
    const categories = data?.map((item) => item.name);

    const seriesNames = Array.from(
        new Set(
            data?.flatMap((item) => {
                if (
                    item?.value?.chart_number?.data &&
                    Array.isArray(item?.value?.chart_number?.data)
                ) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    return item?.value?.chart_number?.data?.map((d: any) =>
                        String(d.name || '')
                    );
                }
                return [];
            })
        )
    );
    const colors = generateColors(data.length || 1);
    const series = seriesNames?.map((seriesName, index) => ({
        name: seriesName,
        type: 'bar',
        stack: 'total',
        label: {
            show: true,
            position: isHorizontal ? 'right' : 'top',
            formatter: (params: { value: number }) => {
                return Number(params.value) === 0 ? '' : params.value + '%';
            },
        },
        barWidth: 'auto',
        barMinWidth: 5,
        barMaxWidth: 50,
        data: data?.map((item) => {
            const found = item.value?.chart_number?.data.find(
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (d: any) => String(d.name) === seriesName
            );
            return {
                name: item.name,
                value: found?.value_percent ?? 0,
                total: item.total,
            };
        }),
        itemStyle: {
            color: colors[index],
        },
    }));
    const option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            formatter: function (params: any) {
                let tooltipContent = `<strong>${params[0].axisValue}</strong><br/>`; // Hiển thị giá trị trục X
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                params.forEach((item: any) => {
                    tooltipContent += `
                                <span style="display:inline-block;width:10px;height:10px;
                                background-color:${item.color};border-radius:50%;margin-right:5px;"></span>${item.seriesName}:
                                <strong>${getValueFromPercent(item.value, item.data.total, 0)}</strong><br/>`;
                });

                return tooltipContent;
            },
        },
        legend: {
            top: 10,
            type: 'scroll',
            icon: 'circle',
            data: seriesNames,
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
        },
        xAxis: isHorizontal
            ? { type: 'value' }
            : { type: 'category', data: categories },
        yAxis: isHorizontal
            ? { type: 'category', data: categories }
            : { type: 'value' },
        series: series,
    };

    return <EChartsReact style={{ height: 500 }} option={option} />;
};

export default QuestionStackedColumnChartCompare;
